import React from "react";
import { Plus } from "lucide-react";
import { story } from "../mock";
import { useReveal } from "../hooks/useReveal";

const OurStory = () => {
  const { ref, inView } = useReveal();
  return (
    <section id="our-story" className="py-24" style={{ background: "var(--wine)" }}>
      <div className="max-w-[1360px] mx-auto px-6 md:px-10 grid lg:grid-cols-2 gap-16 items-center">
        {/* Image */}
        <div ref={ref} className={`relative reveal ${inView ? "in-view" : ""}`}>
          <div
            className="absolute rounded-full hidden md:flex"
            style={{ top: -34, left: -34, width: 70, height: 70, border: "1px solid rgba(233,220,196,0.4)" }}
          />
          <div className="relative overflow-hidden rounded-sm" style={{ aspectRatio: "4/5" }}>
            <img src={story.image} alt="Woman in burgundy saree" className="w-full h-full object-cover" />
          </div>
          <div
            className="absolute -bottom-8 right-4 md:right-8 px-8 py-7 max-w-[280px]"
            style={{ background: "var(--rose)", color: "var(--wine)" }}
          >
            <p className="font-display text-2xl leading-snug">
              {story.overlay[0]}<br />
              <span className="italic">{story.overlay[1]}</span>
            </p>
          </div>
        </div>

        {/* Text */}
        <div className="lg:pl-8">
          <span className="eyebrow" style={{ color: "var(--gold)" }}>{story.eyebrow}</span>
          <h2 className="font-display leading-[0.95] mt-6" style={{ color: "var(--cream)" }}>
            <span className="block font-bold" style={{ fontSize: "clamp(2.4rem,5vw,4.4rem)" }}>{story.titleTop}</span>
            <span className="block italic font-medium" style={{ fontSize: "clamp(2.4rem,5vw,4.4rem)" }}>{story.titleItalic}</span>
          </h2>
          <div className="mt-8 space-y-5 max-w-lg">
            {story.paragraphs.map((p) => (
              <p key={p.slice(0, 24)} className="font-body leading-relaxed" style={{ color: "rgba(244,237,224,0.8)" }}>{p}</p>
            ))}
          </div>
          <button
            className="link-underline flex items-center gap-2 font-mono2 mt-9"
            style={{ fontSize: "0.7rem", letterSpacing: "0.16em", color: "var(--cream)" }}
          >
            {story.link.toUpperCase()} <Plus size={15} />
          </button>
        </div>
      </div>
    </section>
  );
};

export default OurStory;
